import suggestService from '@/apis/suggest/service';
import BaseIconSvg from '@/components/bases/BaseIconSvg';
import BaseTreeSelect from '@/components/bases/BaseSelectTree';
import { tagRender } from '@/components/bases/BaseTag';
import useTimelineStore from '@/screens/Timeline/store';
import useGlobalConfigs from '@/stores/globalConfigs';
import { Button, Drawer, Flex } from 'antd';
import * as React from 'react';

export interface IFilterTimelineProps {}

export default function FilterTimeline(props: IFilterTimelineProps) {
  const [open, setOpen] = React.useState<boolean>(false);
  const filterEmr = useGlobalConfigs((s) => s.phrConfigs?.filterEmr);
  const conditionTimeline = useTimelineStore((s) => s.conditionTimeline);
  const setConditionTimeline = useTimelineStore((s) => s.setConditionTimeline);
  const resetConditionTimeline = useTimelineStore((s) => s.resetConditionTimeline);
  const { data } = suggestService.useGetTags();
  const filterTag = [
    {
      title: 'Tất cả',
      value: 'all',
      key: 'all',
      children: data?.data?.map((d: any) => ({ title: d.text, value: d.text, key: d.text })),
    },
  ];

  return (
    <>
      <Button onClick={() => setOpen(true)} className="border-none shadow-none p-2">
        <BaseIconSvg src="/icons/Regular/Filter - icon.svg" className="wh-[16px]" />
      </Button>
      <Drawer
        height={'auto'}
        className="rounded-b-lg"
        title={
          <div className="flex justify-between items-center">
            <div>Tìm kiếm emr</div>
            <Flex gap={8}>
              <Button
                danger
                onClick={() => {
                  resetConditionTimeline();
                  setOpen(false);
                }}
              >
                Hủy lọc
              </Button>
              <Button onClick={() => setOpen(false)}>Đóng</Button>
            </Flex>
          </div>
        }
        placement={'top'}
        open={open}
        onClose={() => setOpen(false)}
      >
        <Flex gap={8}>
          <div className="w-1/2">
            <div className="mb-2">Lọc theo EMR:</div>
            <BaseTreeSelect
              value={conditionTimeline.types}
              onChange={(v) => setConditionTimeline((s) => ({ ...s, types: v }))}
              placeholder="Chọn EMR"
              treeCheckable
              showSearch
              filterTreeNode={(searchValue: string, option: any) => {
                return option?.title?.toLowerCase()?.includes(searchValue?.toLowerCase());
              }}
              tagRender={tagRender}
              showCheckedStrategy="SHOW_CHILD"
              treeData={filterEmr}
              treeDefaultExpandedKeys={['all']}
              popupMatchSelectWidth={false}
              maxTagCount={3}
              maxTagTextLength={20}
            />
          </div>
          <div className="w-1/2">
            <div className="mb-2">Lọc theo Tags:</div>

            <BaseTreeSelect
              value={conditionTimeline.tags}
              onChange={(v) => setConditionTimeline((s) => ({ ...s, tags: v }))}
              treeCheckable
              placeholder="Chọn nhãn"
              tagRender={tagRender}
              showSearch
              maxTagCount={3}
              maxTagTextLength={20}
              treeDefaultExpandedKeys={['all']}
              treeData={filterTag}
            />
          </div>
        </Flex>
      </Drawer>
    </>
  );
}
